import { AxiosError } from 'axios'
import { z } from 'zod'

import { useTranslation } from '@flecto/translations'
import { type CoreApiResponseErrorValidation } from '@flecto/types'

import { type BusinessInfoFormValues } from '../components/BusinessInfoFormProvider'

export function useBusinessInfoSchema() {
  const { t } = useTranslation('shared', { keyPrefix: 'validation' })

  const schema = z.object({
    business_name: z
      .string({ invalid_type_error: t('required') })
      .min(2, { message: t('required') }),
    public_email: z
      .string({ invalid_type_error: t('required') })
      .min(2, { message: t('required') })
      .email(t('email')),
    public_phone_number: z
      .string({ invalid_type_error: t('required') })
      .min(2, { message: t('required') }),
  })

  const validateResponseErrors = (e: unknown) => {
    const errors: { field: string; message: string }[] = []

    if (e instanceof AxiosError && e.response) {
      const { status, data } = e.response

      if (
        status === 422 &&
        (data as CoreApiResponseErrorValidation).errors?.find(
          (error) => error.field === 'user[public_phone_number]'
        )
      ) {
        errors.push({ field: 'public_phone_number', message: t('invalid') })
      }
    }

    return errors
  }

  const initialValues: Partial<BusinessInfoFormValues> = {
    business_name: '',
    vat_number: '',
    public_email: '',
    public_phone_number: '',
    public_phone_number_country_code: '+351',
    business_category_id: '',
    terms_and_conditions: '',
    legal_address: {
      id: '',
      latitude: 0,
      longitude: 0,
      label: 'Legal address',
      address_label: 'Legal address',
      address_city: '',
      address_region: '',
      address_street: '',
      address_postal_code: '',
      address_country_code: 'PT',
    },
  }

  return { schema, initialValues, validateResponseErrors }
}
